import React from 'react';

import { MealHeaderRow } from '../MealHeaderRow/MealHeaderRow';
import { MealRow } from '../MealRow/MealRow';
import { MealGridContainer } from '../MealGridContainer/MealGridContainer';

type WorkoutMealsTableProps = {
  isEditMode: boolean;
};

const WorkoutMealsTable = ({ isEditMode }: WorkoutMealsTableProps) => {
  return (
    <MealGridContainer>
      <MealHeaderRow />
      <MealRow meal="preWorkout" mealFormKey="preWorkout" isEditMode={isEditMode} />
      <MealRow meal="postWorkout" mealFormKey="postWorkout" isEditMode={isEditMode} />
    </MealGridContainer>
  );
};

export { WorkoutMealsTable };
